import { render, staticRenderFns } from "./PublishValidationModal.vue?vue&type=template&id=b59d2edc"
import script from "./PublishValidationModal.vue?vue&type=script&lang=js"
export * from "./PublishValidationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports